import React from 'react'
import injectSheet from 'react-jss'
import styles from './create-dialog.styles'
import { Modal, ModalHeader, ModalFooter } from 'pobble-components/dist/modal'
import SlideForm from '../slide-form/slide-form'
import Button from 'pobble-components/dist/button'

const TextSlideCreateDialog = ({
  classes,
  modalOpened,
  onClose,
  onSubmit,
  pending
}) => {
  return (
    <Modal closeButton isOpen={modalOpened} requestClose={onClose}>
      <ModalHeader>Create text slide</ModalHeader>
      <SlideForm
        initialValues={{ title: '', text: '' }}
        onSubmit={onSubmit}
        footer={({ isValid }) => (
          <ModalFooter alignRight childrenGap>
            <Button action={onClose} tall simple>
              Cancel
            </Button>
            <Button tall type="submit" disabled={pending || !isValid}>
              {!pending && 'Create slide'}
              {pending && 'Creating a slide'}
            </Button>
          </ModalFooter>
        )}
      />
    </Modal>
  )
}

export default injectSheet(styles)(TextSlideCreateDialog)
